import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinmoshi() {



  const cardData = {
"keyword": "Mini Bus On Rent in Moshi",

"headingDescription":
  "Aaradhya Travels offers reliable Mini Bus On Rent in Moshi Pune for corporate travel, employee transportation, weddings, family trips, school tours, airport transfers, and outstation group journeys. Our fleet includes comfortable 14, 17, 20, 25, 32, and 35-seater mini buses equipped with air-conditioning, pushback seats, spacious interiors, and experienced drivers familiar with Moshi, Chikhali, Spine Road, and PCMC industrial routes. We ensure safe, comfortable, and punctual group transportation with doorstep pickup from Moshi and nearby residential and industrial areas.",

"topPlaces": [
{
"title": "Kauncha Waterfall",
"description":
"Kauncha Waterfall is a hidden natural waterfall destination in the Sahyadri region known for its untouched beauty, dense greenery, and seasonal heavy water flow during monsoon. It is a perfect offbeat group travel destination from Pune for nature lovers, photography groups, and adventure seekers looking for peaceful trekking experiences away from city crowds."
},
{
"title": "Torna Fort",
"description":
"Torna Fort, also known as Prachandagad, is one of the oldest and highest forts in Pune district famous for its historical significance in the Maratha Empire. It offers challenging trekking routes, breathtaking valley views, and ancient fort ruins. It is highly popular among adventure groups and trekking enthusiasts from Pune."
},
{
"title": "Harishchandragad",
"description":
"Harishchandragad is a legendary hill fort known for its extreme trekking routes, Konkan Kada cliff view, caves, and ancient temples. It attracts adventure seekers, camping groups, and trekking lovers from Pune looking for challenging weekend expeditions and sunrise viewpoints."
},
{
"title": "Sandhan Valley",
"description":
"Sandhan Valley is often called the Grand Canyon of Maharashtra, known for narrow rock passages, rappelling, camping, and adventure trekking. It is a top destination for extreme adventure groups, youth trips, and organized trekking tours from Pune."
},
{
"title": "Devkund Waterfall",
"description":
"Devkund Waterfall is a pristine hidden waterfall located deep inside forest trails, known for its turquoise water and trekking adventure route. It is one of the most popular monsoon trekking destinations for group travelers from Pune seeking natural beauty and forest exploration."
},
{
"title": "Aamby Valley",
"description":
"Aamby Valley is a luxury township near Lonavala known for scenic landscapes, private roads, lakes, and premium resorts. It is a popular destination for corporate group outings, luxury tours, and weekend relaxation trips from Pune."
},
{
"title": "Ghangad Fort",
"description":
"Ghangad Fort is a small but scenic fort near Tamhini Ghat known for easy trekking routes, panoramic valley views, and historical ruins. It is suitable for beginner trekking groups and nature trips from Pune."
},
{
"title": "Tikona Fort",
"description":
"Tikona Fort is a pyramid-shaped hill fort known for its short trek, ancient caves, and panoramic views of Pawna Lake. It is a popular weekend trekking destination for group travelers from Pune."
},
{
"title": "Andharban Jungle Trek",
"description":
"Andharban Jungle Trek is a dense forest trail known for deep jungle walks, waterfalls, misty valleys, and thrilling monsoon trekking experiences. It is widely chosen by adventure groups and trekking clubs from Pune."
},
{
"title": "Rajmachi Night Trek",
"description":
"Rajmachi Night Trek is a famous trekking experience involving night hiking through forest trails leading to historic forts and sunrise viewpoints. It is highly popular among adventure groups, college trips, and trekking enthusiasts from Pune."
}
],



services: [
  {
    name: "Moshi Mini Bus Hire Pune",
    description: "Moshi mini bus hire Pune service provides reliable transportation for airport transfers, office outings, sightseeing tours, family trips, and group travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi Pune. Flexible booking options allow convenient mini bus hire reservations."
  },
  {
    name: "Moshi to Pune Bus Rental",
    description: "Moshi to Pune bus rental service provides comfortable transportation for office commute, airport travel, sightseeing tours, and passenger movement requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for family and corporate groups. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi and Pune city. Flexible booking options allow convenient Pune bus rental reservations."
  },
  {
    name: "Moshi AC Mini Bus",
    description: "Moshi AC mini bus service provides premium air-conditioned transportation for business travel, airport transfers, office outings, sightseeing tours, and group journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Moshi Pune. Flexible booking options allow convenient AC mini bus reservations."
  },
  {
    name: "Moshi Non AC Bus Hire",
    description: "Moshi non AC bus hire service offers affordable transportation for educational tours, office travel, sightseeing trips, wedding functions, and group journeys. Spacious seating ensures comfortable travel suitable for budget-friendly local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi Pune. Flexible booking options allow convenient non AC bus hire reservations."
  },
  {
    name: "17 Seater Moshi Bus",
    description: "17 seater Moshi bus service provides spacious transportation for family vacations, office outings, educational tours, and group travel requirements. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Moshi Pune. Flexible booking options allow convenient 17 seater bus reservations."
  },
  {
    name: "25 Seater Moshi Bus",
    description: "25 seater Moshi bus service offers reliable transportation for corporate events, wedding functions, office travel, educational tours, and sightseeing journeys. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for larger passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Moshi Pune. Flexible booking options allow convenient 25 seater bus reservations."
  },
  {
    name: "Moshi Industrial Bus Service",
    description: "Moshi industrial bus service provides professional transportation for factory workers, industrial staff, company employees, and daily shift transportation requirements. Spacious buses ensure smooth travel suitable for industrial and commercial transportation needs. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from factories, offices, industrial hubs, and residential areas across Moshi Pune. Flexible booking options allow convenient industrial bus service reservations."
  },
  {
    name: "Moshi MIDC Bus Hire",
    description: "Moshi MIDC bus hire service offers reliable transportation for industrial staff, office employees, factory workers, and corporate travel requirements. Spacious buses ensure smooth journeys suitable for daily office commute and industrial employee transportation. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from MIDC offices, factories, industrial areas, and residential locations across Moshi Pune. Flexible booking options allow convenient MIDC bus hire reservations."
  },
  {
    name: "Moshi Corporate Transport Bus",
    description: "Moshi corporate transport bus service provides professional transportation for office staff, conferences, business meetings, corporate outings, and employee travel requirements. Comfortable buses ensure smooth journeys suitable for executive passengers and office teams. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and business locations across Moshi Pune. Flexible booking options allow convenient corporate transport bus reservations."
  },
  {
    name: "Moshi Wedding Bus Hire",
    description: "Moshi wedding bus hire service offers stylish transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional drivers ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Moshi Pune. Flexible booking options allow convenient wedding bus hire reservations."
  },
  {
    name: "Moshi Outstation Bus",
    description: "Moshi outstation bus service provides dependable long-distance transportation for Goa tours, pilgrimage journeys, sightseeing trips, family vacations, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "Moshi to Lonavala Bus",
    description: "Moshi to Lonavala bus service offers comfortable transportation for sightseeing tours, family vacations, weekend trips, and tourist travel to the hill station destination. Spacious buses ensure smooth expressway travel suitable for family and group journeys. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Moshi Pune. Flexible booking options allow convenient Lonavala bus reservations."
  },
  {
    name: "Moshi Family Trip Bus",
    description: "Moshi family trip bus service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious buses ensure comfortable journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Moshi Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Moshi Airport Pickup Bus",
    description: "Moshi airport pickup bus service offers reliable transportation for airport pickups, business travelers, family travel, office staff movement, and tourist passenger transfers. Spacious buses ensure comfortable travel suitable for local and outstation airport transportation requirements. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Moshi Pune. Flexible booking options allow convenient airport pickup bus reservations."
  },
  {
    name: "Moshi Picnic Bus Pune",
    description: "Moshi picnic bus Pune service provides comfortable transportation for family outings, school trips, office picnics, sightseeing tours, and holiday travel. Spacious buses ensure smooth journeys suitable for local and outstation picnic travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Moshi Pune. Flexible booking options allow convenient picnic bus reservations."
  },
  {
    name: "Moshi Affordable Bus Rental",
    description: "Moshi affordable bus rental service provides economical transportation for educational tours, office travel, sightseeing journeys, family outings, and local or outstation group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi Pune. Flexible booking options allow convenient affordable bus rental reservations."
  },
  {
    name: "Moshi Luxury Bus Hire",
    description: "Moshi luxury bus hire service offers premium transportation with elegant interiors and spacious seating for corporate travel, weddings, sightseeing tours, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, luxury hotels, and airports across Moshi Pune. Flexible booking options allow convenient luxury bus hire reservations."
  },
  {
    name: "Moshi Group Travel Bus",
    description: "Moshi group travel bus service provides spacious transportation for educational tours, sightseeing journeys, family vacations, office outings, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Moshi Pune. Flexible booking options allow convenient group travel bus reservations."
  },
  {
    name: "Moshi School Trip Bus",
    description: "Moshi school trip bus service provides safe and reliable transportation for educational tours, school picnics, student outings, and academic travel requirements. Spacious buses ensure comfortable journeys suitable for students, teachers, and school groups. Professional drivers ensure punctual transportation and safe driving services throughout the journey. Pickup services are available from schools, homes, and educational institutions across Moshi Pune. Flexible booking options allow convenient school trip bus reservations."
  },
  {
    name: "Moshi Tourist Bus Booking",
    description: "Moshi tourist bus booking service provides dependable transportation for sightseeing tours, holiday vacations, family outings, and tourist travel requirements. Spacious buses ensure comfortable journeys suitable for local and outstation tourism activities. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Moshi Pune. Flexible booking options allow convenient tourist bus booking reservations."
  },
  {
    name: "Moshi Chinchwad Bus Service",
    description: "Moshi Chinchwad bus service offers dependable transportation for office commute, local travel, educational tours, and passenger movement requirements. Spacious buses ensure smooth journeys suitable for family and corporate passenger groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi and Chinchwad Pune. Flexible booking options allow convenient Chinchwad bus service reservations."
  },
  {
    name: "Moshi Nigdi Bus Rental",
    description: "Moshi Nigdi bus rental service provides comfortable transportation for office travel, wedding functions, sightseeing journeys, and educational tours. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation passenger movement. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi and Nigdi Pune. Flexible booking options allow convenient Nigdi bus rental reservations."
  },
  {
    name: "Moshi Ravet Bus Service",
    description: "Moshi Ravet bus service provides dependable transportation for office commute, local travel, sightseeing journeys, and passenger movement requirements. Spacious buses ensure smooth journeys suitable for family and corporate passenger groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Moshi and Ravet Pune. Flexible booking options allow convenient Ravet bus service reservations."
  },
  {
    name: "Moshi Event Bus Hire",
    description: "Moshi event bus hire service provides dependable transportation for corporate functions, concerts, exhibitions, weddings, conferences, and social gatherings. Spacious buses ensure smooth journeys suitable for local and outstation event travel requirements. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and event venues across Moshi Pune. Flexible booking options allow convenient event bus hire reservations."
  },
  {
    name: "Moshi Local Transport Bus",
    description: "Moshi local transport bus service offers comfortable transportation for city tours, office commute, local passenger movement, and family outings within Pune. Spacious buses ensure smooth journeys suitable for daily local travel and group transportation requirements. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, schools, and hotels across Moshi Pune. Flexible booking options allow convenient local transport bus reservations."
  }
],

tableData: [
  ["Moshi Mini Bus Hire Pune", "Moshi to Pune Bus Rental"],
  ["Moshi AC Mini Bus", "Moshi Non AC Bus Hire"],
  ["17 Seater Moshi Bus", "25 Seater Moshi Bus"],
  ["Moshi Industrial Bus Service", "Moshi MIDC Bus Hire"],
  ["Moshi Corporate Transport Bus", "Moshi Wedding Bus Hire"],
  ["Moshi Outstation Bus", "Moshi to Lonavala Bus"],
  ["Moshi Family Trip Bus", "Moshi Airport Pickup Bus"],
  ["Moshi Picnic Bus Pune", "Moshi Affordable Bus Rental"],
  ["Moshi Luxury Bus Hire", "Moshi Group Travel Bus"],
  ["Moshi School Trip Bus", "Moshi Tourist Bus Booking"],
  ["Moshi Chinchwad Bus Service", "Moshi Nigdi Bus Rental"],
  ["Moshi Ravet Bus Service", "Moshi Event Bus Hire"],
  ["Moshi Local Transport Bus", "Moshi Group Travel Bus"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Mini Bus On Rent in Moshi",
        WhyChoosedescription: "Aaradhya Travels provides reliable mini bus rental service in Moshi with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate tours, family trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Mini Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable mini bus on rent in Moshi with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking Service",
        WhyChoosedescription: "Our mini bus rental service in Moshi operates 24 hours for airport transfers, employee transportation, weddings, school trips, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Mini Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses suitable for office teams, family groups, wedding travel, tourists, and school transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Moshi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Moshi, Bhosari, Chikhali, Pimpri, Chinchwad, Nigdi, Dehu Road, and nearby Pune locations for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is mini bus on rent in Moshi?", answer: "Mini bus rental service in Moshi provides comfortable group transportation for corporate travel, family tours, weddings, school trips, and outstation journeys." },
    { question: "Is mini bus booking available 24 hours in Moshi?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus rental service in Moshi." },
    { question: "Which mini bus seating options are available?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses for different group travel requirements." },
    { question: "Can I book mini bus for outstation travel from Moshi?", answer: "Yes, customers can book mini buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Moshi." },
    { question: "Do you provide mini buses for corporate events in Moshi?", answer: "Yes, Aaradhya Travels provides mini bus rental service for corporate meetings, office outings, conferences, and employee transportation in Moshi." },
    { question: "Are AC and Non-AC mini buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly group travel." },
    { question: "Can I book mini bus online in Moshi?", answer: "Yes, customers can easily book mini bus rental service online or through phone booking." },
    { question: "Do you provide mini buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for weddings, family vacations, and group tours." },
    { question: "Are mini bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for mini bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Bhosale",
    feedback:
      "Travel from Moshi with a group became very convenient with a mini bus arranged by Aaradhya Travels. The journey was comfortable, and everyone could sit together without any travel stress.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rachana Kulkarni",
    feedback:
      "Aaradhya Travels managed our mini bus requirement in Moshi very smoothly. The vehicle was clean and spacious, and the entire group travel experience felt well organized and hassle-free.",
    rating: 5
  }
];


  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Moshi",
  "image": "https://www.aaradhyatravels99.com/assets/images/mini-bus-on-rent-in-moshi.jpg",
  "description": "Book Mini Bus on rent in Moshi Pune with Aaradhya Travels for industrial transport, corporate travel, weddings, airport transfers, family trips, picnic tours, and outstation journeys. Available AC and Non-AC 17 and 25 seater mini buses across Moshi MIDC and PCMC region.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7840"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/mini-bus-on-rent-in-moshi"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Mini Bus on Rent in Moshi Pune | Industrial & Corporate Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Mini Bus on rent in Moshi Pune with Aaradhya Travels. Affordable AC and Non-AC 17 and 25 seater mini buses available for industrial transport, corporate travel, weddings, airport pickup, family trips, picnic tours, and outstation journeys."
  />

  <meta
    name="keywords"
    content="Moshi mini bus hire Pune, Moshi to Pune bus rental, Moshi AC mini bus, Moshi non AC bus hire, 17 seater Moshi bus, 25 seater Moshi bus, Moshi industrial bus service, Moshi MIDC bus hire, Moshi corporate transport bus, Moshi wedding bus hire, Moshi outstation bus, Moshi to Lonavala bus, Moshi family trip bus"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinmoshi ;